(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var bars = document.querySelectorAll("[data-sticky-atc]");
    bars.forEach(setupStickyAddToCart);
  });

  function setupStickyAddToCart(bar) {
    var productDetails = bar.closest(".product__details");
    if (!productDetails) return;

    var mainSubmit = productDetails.querySelector("[data-add-to-cart]");
    if (!mainSubmit) return;

    var submitBtn = bar.querySelector("[data-sticky-atc-submit]");
    var submitText = bar.querySelector("[data-sticky-atc-submit-text]");
    var sizesWrap = bar.querySelector("[data-sticky-atc-sizes]");

    var labels = {
      available: mainSubmit.dataset.langAvailable,
      unavailable: mainSubmit.dataset.langUnavailable,
      soldOut: mainSubmit.dataset.langSoldOut
    };

    var sourceRegions = productDetails.querySelector(".regions-container");
    var sourceSizes = productDetails.querySelector(".product-sizes");
    if (sourceSizes && sizesWrap) {
      if (sourceRegions) {
        sizesWrap.appendChild(sourceRegions.cloneNode(true));
      }

      var sizesClone = sourceSizes.cloneNode(true);
      sizesClone.removeAttribute("id");
      sizesWrap.appendChild(sizesClone);
      sizesWrap.hidden = false;
    }

    if (sizesWrap) sizesWrap.addEventListener("click", function (e) {
      var regionButton = e.target.closest(".btn-region");
      if (!regionButton) return;
      e.stopPropagation();

      var region = regionButton.dataset.label;
      sizesWrap.querySelectorAll(".btn-region").forEach(function (btn) {
        btn.classList.toggle("selected", btn === regionButton);
      });

      var sizeButtons = sizesWrap.querySelectorAll(".shoes-sizes li, .product-sizes li");
      sizeButtons.forEach(function (sizeButton) {
        var newLabel = sizeButton.getAttribute("data-size-" + region);
        if (newLabel) sizeButton.innerHTML = newLabel;
      });
    });

    forwardLinkTo(bar.querySelector('[data-sticky-atc-trigger="size-chart"]'), function () {
      return productDetails.querySelector(".sizing-chart-modal-link, [data-popup-trigger]");
    });
    forwardLinkTo(bar.querySelector('[data-sticky-atc-trigger="find-fit"]'), function () {
      return document.getElementById("kleep-size-button");
    });

    function visibleText(el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          for (var ancestor = node.parentElement; ancestor && ancestor !== el; ancestor = ancestor.parentElement) {
            var style = getComputedStyle(ancestor);
            if (style.display === "none" || style.visibility === "hidden") {
              return NodeFilter.FILTER_REJECT;
            }
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      var text = "";
      var node;
      while ((node = walker.nextNode())) {
        text += node.textContent;
      }
      return text.replace(/\s+/g, " ").trim();
    }

    function forwardLinkTo(stickyLink, findRealTrigger) {
      if (!stickyLink) return;

      function sync() {
        var real = findRealTrigger();
        var text = real ? visibleText(real) : "";
        if (real && text) {
          stickyLink.hidden = false;
          stickyLink.textContent = text;
        } else {
          stickyLink.hidden = true;
        }
      }

      sync();

      var checks = 0;
      var maxChecks = 14;
      var interval = setInterval(function () {
        sync();
        checks++;
        if (checks >= maxChecks) clearInterval(interval);
      }, 500);

      stickyLink.addEventListener("click", function (e) {
        e.preventDefault();
        var current = findRealTrigger();
        if (current) current.click();
      });
    }

    var notifyMeLabel = bar.dataset.notifyMeLabel || "Notify Me When Available";
    var productTitle = bar.dataset.productTitle || "";

    function showNotifyMe(variant) {
      submitBtn.setAttribute("data-notify-me-trigger", "");
      submitBtn.dataset.notifyVariantId = variant.id;
      submitBtn.dataset.notifyProductTitle = productTitle;
      submitBtn.classList.remove("sticky-add-to-cart__submit--disabled");
      submitBtn.removeAttribute("aria-disabled");
      submitBtn.disabled = false;
      submitText.innerHTML =
        '<span class="sticky-add-to-cart__submit-label sticky-add-to-cart__submit-label--solo">' +
        notifyMeLabel +
        "</span>";
    }

    submitBtn.addEventListener("click", function (e) {
      e.preventDefault();
      if (submitBtn.disabled) return;
      if (submitBtn.hasAttribute("data-notify-me-trigger")) return;
      mainSubmit.click();
    });

    function syncSizeLists(variant) {
      productDetails.querySelectorAll(".product-sizes").forEach(function (list) {
        list.querySelectorAll(".variant-option-btn").forEach(function (btn) {
          var sizeValue = btn.querySelector("[data-size]")?.dataset.size || btn.dataset.sizeDefault;
          var isActive = sizeSelect
            ? !!sizeSelect.value && sizeValue === sizeSelect.value
            : !!variant && String(btn.dataset.variantId) === String(variant.id);
          btn.classList.toggle("active", isActive);
          btn.setAttribute("aria-checked", isActive ? "true" : "false");
          btn.setAttribute("tabindex", isActive ? "0" : "-1");
        });
      });
    }

    function priceMarkupFor(variant) {
      var priceEl = productDetails.querySelector(
        '[variant-price-display][variant-id="' + variant.id + '"]'
      );
      return priceEl ? priceEl.innerHTML : "";
    }

    function setLabelWithPrice(text, variant) {
      submitText.innerHTML =
        '<span class="sticky-add-to-cart__submit-label">' +
        text +
        '</span><span class="sticky-add-to-cart__price">' +
        (variant ? priceMarkupFor(variant) : "") +
        "</span>";
    }

    function setDisabledLabel(text) {
      submitText.innerHTML =
        '<span class="sticky-add-to-cart__submit-label sticky-add-to-cart__submit-label--solo">' +
        text +
        "</span>";
      submitBtn.classList.add("sticky-add-to-cart__submit--disabled");
      submitBtn.setAttribute("aria-disabled", "true");
      submitBtn.disabled = true;
    }

    function render(variant) {
      syncSizeLists(variant);
      submitBtn.removeAttribute("data-notify-me-trigger");

      if (!variant) {
        setDisabledLabel(labels.unavailable);
        return;
      }

      if (!variant.available) {
        showNotifyMe(variant);
        return;
      }

      submitBtn.classList.remove("sticky-add-to-cart__submit--disabled");
      submitBtn.removeAttribute("aria-disabled");
      submitBtn.disabled = false;
      setLabelWithPrice(labels.available, variant);
    }

    document.addEventListener("product:variant-change", function (e) {
      render(e.detail.variant);
    });
  }
})();
